<div class="users-table-container">
  <button nz-button nzType="primary" [routerLink]="['/management/invite-user']">
    {{'Invite User'| translate }}
  </button>
  <nz-table [nzData]="users" [nzLoading]="isLoading">
    <thead>
      <tr>
        <th>{{'First Name' | translate}}</th>
        <th>{{'Last Name' | translate}}</th>
        <th>{{'Email' | translate}}</th>
        <th>{{'Position' | translate}}</th>
        <th>{{'Role' | translate}}</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let user of users"
        [ngClass]="{
          'activated-user': user.active,
          'deactivated-user': !user.active
        }"
      >
        <td>{{ user.firstName }}</td>
        <td>{{ user.lastName }}</td>
        <td>{{ user.email }}</td>
        <td>{{ user.position }}</td>
        <td>{{ user.role }}</td>
        <td>
          <nz-space>
            <ng-container *nzSpaceItem>
              <button
                *isAuthorized="'Admin'"
                nz-button
                class="border-radius"
                (click)="resetPasswordRequest(user.email)"
              >
                <nz-space>
                  <i *nzSpaceItem class="fal fa-key"></i>
                  <span *nzSpaceItem>{{'Reset Password' | translate}}</span>
                </nz-space>
              </button>
            </ng-container>
            <button
              *nzSpaceItem
              nz-button
              class="border-radius"
              [routerLink]="['/management/user', user.email]"
            >
              <nz-space>
                <i *nzSpaceItem class="fal fa-user-edit"></i>
                <span *nzSpaceItem>{{'Edit' | translate}}</span>
              </nz-space>
            </button>
            <ng-container *nzSpaceItem>
              <button
                *isAuthorized="'Admin'"
                nz-button
                class="border-radius"
                (click)="changeUserActivationStatus(user.email, !user.active)"
                [nzDanger]="user.active"
              >
                <nz-space>
                  <ng-container *ngIf="user.active">
                    <i *nzSpaceItem class="fal fa-times-circle"></i>
                    <span *nzSpaceItem>{{ 'Deactivate' | translate | locale }}</span>
                  </ng-container>
                  <ng-container *ngIf="!user.active">
                    <i *nzSpaceItem class="fal fa-check-circle"></i>
                    <span *nzSpaceItem>{{ 'Activate' | translate | locale }}</span>
                  </ng-container>
                </nz-space>
              </button>
            </ng-container>
          </nz-space>
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>
